import React, { useState, useEffect } from 'react'
import { LocalizedLink } from 'gatsby-plugin-i18n-l10n'
import { useTheme } from 'styled-components'
import { useIntl } from 'react-intl'

import { HeaderStyled, MobileMenuStyled } from '../styles/HeaderStyled'
import { TitleS, BodyS } from '../styles/Typography'

import ButikLogoSmall from './icons/ButikLogoSmall'

/**
 * The main header.
 * @param {ComponentProps} props
 * @param {String} props.textColor
 * @param {String} props.backgroundColor
 * @param {String} props.logoColor
 * @param {String} props.logoReverseColor
 * @param {Boolean} props.hideLogo
 * @param {Boolean} props.isAnimatedCover
 * @param {Boolean} props.isZanzibar
 * @returns {StatelessComponent}
 */
const Header = ({
  textColor,
  backgroundColor,
  logoColor,
  logoReverseColor,
  hideLogo,
  isAnimatedCover,
  isZanzibar,
}) => {
  const theme = useTheme()
  const intl = useIntl()

  const [shouldRender, setShouldRender] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  useEffect(() => {
    setShouldRender(true)
  }, [])

  return shouldRender ? (
    <>
      <HeaderStyled textColor={textColor} isAnimatedCover={isAnimatedCover}>
        <div className="header-group top">
          {!hideLogo && (
            <LocalizedLink to="/" className="logo-link">
              <ButikLogoSmall
                className="logo"
                color={logoColor ? logoColor : theme.logoBackground}
              />
            </LocalizedLink>
          )}
          {!isZanzibar && (
            <div className="menu-btn">
              <a>
                <BodyS
                  className="menu-title"
                  color={textColor}
                  weight={700}
                  onClick={() => setIsMenuOpen(!isMenuOpen)}
                >
                  <span className={isMenuOpen ? 'btn-close show' : 'btn-close'}>
                    {intl.formatMessage({ id: 'header_menu_close' })}
                  </span>
                  <span className={isMenuOpen ? 'btn-menu' : 'btn-menu show'}>
                    {intl.formatMessage({ id: 'header_menu_open' })}
                  </span>
                </BodyS>
              </a>
            </div>
          )}
        </div>
      </HeaderStyled>

      <MobileMenuStyled
        backgroundColor={backgroundColor}
        className={isMenuOpen ? 'active' : ''}
      >
        <div className="header-group">
          {!hideLogo && (
            <LocalizedLink to="/" className="logo-link">
              <ButikLogoSmall
                className="logo"
                color={
                  isZanzibar
                    ? theme.backgroundPrimary
                    : logoReverseColor
                    ? logoReverseColor
                    : theme.logoBackground
                }
              />
            </LocalizedLink>
          )}
          <div className="menu-btn">
            <a>
              <BodyS
                className="menu-title"
                color={theme.textHighlight}
                weight={700}
                onClick={() => setIsMenuOpen(!isMenuOpen)}
              >
                <span className={isMenuOpen ? 'btn-close show' : 'btn-close'}>
                  {intl.formatMessage({ id: 'header_menu_close' })}
                </span>
                <span className={isMenuOpen ? 'btn-menu' : 'btn-menu show'}>
                  {intl.formatMessage({ id: 'header_menu_open' })}
                </span>
              </BodyS>
            </a>
          </div>
        </div>
        <div className={isMenuOpen ? 'menu-items open' : 'menu-items close'}>
          <a
            href="https://tickets.butikfestival.com/a8fa5a5eb8bf4a56b1fb3c0c57db908d/butik-2027-ticket-raffle"
            target="_blank"
            rel="noopener noreferrer"
          >
            <TitleS color={theme.textHighlight} className="menu-item item-1">
              {/* {intl.formatMessage({ id: 'header_menu_webshop' })} */}
              {/* {intl.formatMessage({ id: 'header_menu_tickets' })} */}
              {intl.formatMessage({ id: 'header_menu_raffle' })}
            </TitleS>
          </a>
          {/* <LocalizedLink to="/lineup" onClick={() => setIsMenuOpen(false)}>
            <TitleS color={theme.textHighlight} className="menu-item item-2">
              {intl.formatMessage({ id: 'header_menu_lineup' })}
            </TitleS>
          </LocalizedLink> */}
          <LocalizedLink
            to="/festival-a-z"
            onClick={() => setIsMenuOpen(false)}
          >
            <TitleS color={theme.textHighlight} className="menu-item item-2">
              {intl.formatMessage({ id: 'header_menu_festival_a_z' })}
            </TitleS>
          </LocalizedLink>
          <LocalizedLink to="/awareness" onClick={() => setIsMenuOpen(false)}>
            <TitleS color={theme.textHighlight} className="menu-item item-3">
              {intl.formatMessage({ id: 'header_menu_awareness' })}
            </TitleS>
          </LocalizedLink>
          <LocalizedLink
            to="/sustainability"
            onClick={() => setIsMenuOpen(false)}
          >
            <TitleS color={theme.textHighlight} className="menu-item item-4">
              {intl.formatMessage({ id: 'header_menu_sustainability' })}
            </TitleS>
          </LocalizedLink>
          <LocalizedLink to="/zanzibar" onClick={() => setIsMenuOpen(false)}>
            <TitleS color={theme.textHighlight} className="menu-item item-5">
              {intl.formatMessage({ id: 'header_menu_zanzibar' })}
            </TitleS>
          </LocalizedLink>
        </div>
      </MobileMenuStyled>
    </>
  ) : (
    <></>
  )
}

export default Header
